import axios from "@/api/axiosInstance";
import {
  CreateLibraryModuleFromCourseModuleRequest,
  CreateLibraryModuleFromCourseModuleResponse,
} from "./types";

export const createLibraryModuleFromCourseModule = async (
  requestData: CreateLibraryModuleFromCourseModuleRequest,
): Promise<CreateLibraryModuleFromCourseModuleResponse> => {
  const response =
    await axios.post<CreateLibraryModuleFromCourseModuleResponse>(
      "/api/private/learning-center/module-library/from-course-module",
      requestData,
    );
  return response.data;
};
